export default "__VITE_ASSET__SuX5gfRw__"